import type { TranslationKey } from "../locales";
import type { ArticleQuantityState } from "../types";

/**
 * This function returns the translation key for the given article quantity state.
 */
export function getArticleQuantityStateTranslationKey(
	articleQuantityState: ArticleQuantityState,
): TranslationKey {
	switch (articleQuantityState) {
		case "ok":
			return "stock.article_quantity_state.ok";
		case "low":
			return "stock.article_quantity_state.low";
		case "critical":
			return "stock.article_quantity_state.critical";
		case "empty":
			return "stock.article_quantity_state.empty";
	}
}
